export default __webpack_public_path__ + "static/media/shipment-icon.fe476eb1.svg";